module.exports = __webpack_public_path__ + "fe2568d78d499d6488f454108f0ba232.jpg";